import { useExt } from "./ext";
import { useReport } from "./report";
import { UNIT_SORT } from "./unit";


export function UnitList(props) {
    const { Component, filter, ...rest } = props;
    const report = useReport()
    const units = report.units.filter(filter ? filter : () => true);

    return <>
        {units.sort(UNIT_SORT).map(u => <Component key={u.id} unit={u} {...rest} />)}
    </>
}


export function ExtReportUnitKills() {
    const ext = useExt();

    return ext.reportAfterKills();
}